'use strict';

var ProfileChartNextPrevButtonsController = function ProfileChartNextPrevButtonsController($scope, gridRecordsNavigationService, toolbarNextPreviousButtonService) {
  var gridIdForNextPrevButtons = 'flight-summary';
  var rowKey = toolbarNextPreviousButtonService.getRowKeyId(gridIdForNextPrevButtons);
  $scope.buttonState = {
    disablePreviousKeyButton: false,
    disablePreviousRowButton: false,
    disableNextRowButton: false,
    disableNextKeyButton: false
  };
  $scope.previousKeyTooltip = toolbarNextPreviousButtonService.getLeftToolTip(gridIdForNextPrevButtons);
  $scope.nextKeyTooltip = toolbarNextPreviousButtonService.getRightToolTip(gridIdForNextPrevButtons);
  $scope.determineButtonsVisibility = function () {
    $scope.buttonState = gridRecordsNavigationService.buttonState($scope.contextData.visibleRowProperties.displayRows, $scope.contextData.selectedRowIndexes, rowKey, gridIdForNextPrevButtons, $scope.contextData.visibleRowProperties.displayRowFilters, $scope.contextData.visibleRowProperties.allRowFilters);
  };
  $scope.moveToPreviousKey = function () {
    if ($scope.contextData.selectedRowIndexes === undefined) {
      $scope.contextData.selectedRowIndexes = [0];
    }
    var previousKeyIndex = gridRecordsNavigationService.getPreviousKeyIndex($scope.contextData.selectedRowIndexes, rowKey, $scope.contextData.visibleRowProperties.allRowFilters);
    $scope.updateRowSelection(previousKeyIndex);
  };
  $scope.moveToNextKey = function () {
    if ($scope.selectedRowIndexes === undefined) {
      $scope.selectedRowIndexes = [0];
    }
    var nextKeyIndex = gridRecordsNavigationService.getNextKeyIndex($scope.contextData.selectedRowIndexes, rowKey, $scope.contextData.visibleRowProperties.allRowFilters);
    $scope.updateRowSelection(nextKeyIndex);
  };
  $scope.moveToPreviousRow = function () {
    var previousRowIndex = gridRecordsNavigationService.getPreviousRowIndex($scope.contextData.selectedRowIndexes);
    $scope.updateRowSelection(previousRowIndex);
  };
  $scope.moveToNextRow = function () {
    var nextRowIndex = gridRecordsNavigationService.getNextRowIndex($scope.contextData.visibleRowProperties.displayRows, $scope.contextData.selectedRowIndexes);
    $scope.updateRowSelection(nextRowIndex);
  };
  $scope.updateRowSelection = function (rowIndexToSet) {
    $scope.contextData.selectedRowIndexes = [rowIndexToSet];
    $scope.contextData.visibleRowProperties.displayRowFilters = [$scope.contextData.visibleRowProperties.allRowFilters[rowIndexToSet]];
    $scope.contextData.visibleRowProperties.displayRowIndexes = [rowIndexToSet];
    $scope.determineButtonsVisibility();
  };
  $scope.determineButtonsVisibility();
};
ProfileChartNextPrevButtonsController.$inject = ['$scope', 'GridRecordsNavigationService', 'ToolbarNextPreviousButtonService'];
module.exports = ProfileChartNextPrevButtonsController;